export class CiramailActionItemsParameterDto {
    emailInfoCacheId: number;
    action: string;
    value: string;
    currentFolder: string;
}
